import src from "IMAGE";
export default { src, width: 474, height: 403, blurWidth: 0, blurHeight: 0};
